export default class Logger {
  static enabled = false;

  // eslint-disable-next-line no-useless-constructor
  constructor(private name: string) {}

  info(...args: any[]): Logger {
    if (Logger.enabled) {
      console.log(`[${this.name}]`, ...args);
    }
    return this;
  }

  warn(...args: any[]): Logger {
    if (Logger.enabled) {
      console.warn(`[${this.name}]`, ...args);
    }
    return this;
  }

  error(...args: any[]): Logger {
    if (Logger.enabled) {
      console.error(`[${this.name}]`, ...args);
    }
    return this;
  }
}
